import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';
import {
	NgxMediaRecordingStatsService
} from '@go-modules/services/media-recording-stats/media-recording-stats.service';

export const ngxMediaRecordingStatsModule = angular.module('ngxMediaRecordingStatsModule', [])
	.factory('ngxMediaRecordingStatsService', downgradeInjectable(NgxMediaRecordingStatsService) as any)
	.name;
